// src/Components/ZendeskWidget.js

import { useEffect } from 'react';

const ZendeskWidget = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.src = 'https://static.zdassets.com/ekr/snippet.js?key=f22f8099-74a6-44df-b83e-83c01e7017e5';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup the script when the component unmounts
      const existingScript = document.getElementById('ze-snippet');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return null; // No visible component, just the widget
};

export default ZendeskWidget;
